import createReducer from '../utils/createReducer';
import {
  PROJECT_BUSINESS_UNITS_REQUEST,
  PROJECT_BUSINESS_UNIT_FAILURE,
  PROJECT_BUSINESS_UNIT_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [PROJECT_BUSINESS_UNITS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [PROJECT_BUSINESS_UNIT_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [PROJECT_BUSINESS_UNIT_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/projectBusinessUnits.js